/* ==========================================================================
   IRON CREST LEATHER — contact.js
   Inline validation and the confirmation state for the contact form.

   The form in the markup is a real form with real `required` and `type="email"`
   attributes, so with no script the browser validates it itself and the post
   goes to the server. This file takes `novalidate` at runtime — never in the
   markup, or a no-JS visitor would lose validation entirely — so it can put the
   errors next to the fields instead of in the browser's default bubbles, which
   show one at a time and vanish on the next click.

   Shopify: assets/contact.js. The form becomes `{% form 'contact' %}`, the
   field names are already Shopify's (`contact[name]`, `contact[email]`,
   `contact[body]`), and the confirmation below is replaced by the real
   `form.posted_successfully?` branch — see SHOPIFY.md §12.
   ========================================================================== */
(function () {
  function boot() {
    'use strict';

    var form = document.querySelector('[data-contact-form]');
    if (!form) return;
    if (form.icBooted) return;   // already live; the editor replaced a different section
    form.icBooted = true;

    var done = document.querySelector('[data-contact-done]');
    var again = document.querySelector('[data-contact-again]');
    var fields = Array.prototype.slice.call(form.querySelectorAll('input, select, textarea'));

    form.setAttribute('novalidate', 'novalidate');

    /* ------------------------------------------------------------- messages */
    // the browser's own message is already localised and already correct; there
    // is no reason to write worse copies of it in English only
    function messageFor(el) {
      if (el.validity.valueMissing) {
        return el.tagName === 'TEXTAREA'
          ? 'Tell us what it is about.'
          : 'This one is needed.';
      }
      if (el.validity.typeMismatch && el.type === 'email') {
        return 'That does not look like an email address.';
      }
      return el.validationMessage || 'Check this one.';
    }

    function errorNode(el) {
      var field = el.closest('.cfield');
      if (!field) return null;
      var err = field.querySelector('.cfield__err');
      if (!err) {
        err = document.createElement('p');
        err.className = 'cfield__err';
        err.id = el.id + '-err';
        err.hidden = true;
        field.appendChild(err);
      }
      return err;
    }

    function mark(el, bad) {
      var field = el.closest('.cfield');
      var err = errorNode(el);
      if (!field || !err) return;

      field.classList.toggle('is-bad', bad);
      el.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (bad) {
        err.textContent = messageFor(el);
        err.hidden = false;
        el.setAttribute('aria-describedby', err.id);
      } else {
        err.hidden = true;
        el.removeAttribute('aria-describedby');
      }
    }

    /* ---------------------------------------------------------- validation */
    // validate on blur, never on input: telling someone their email is wrong
    // while they are halfway through typing it is noise, not help
    fields.forEach(function (el) {
      el.addEventListener('blur', function () {
        if (el.value || el.hasAttribute('required')) mark(el, !el.checkValidity());
      });
      // once a field is marked bad, correcting it should clear the mark straight
      // away rather than making the reader blur again to find out
      el.addEventListener('input', function () {
        if (el.closest('.cfield').classList.contains('is-bad') && el.checkValidity()) mark(el, false);
      });
    });

    form.addEventListener('submit', function (e) {
      var bad = fields.filter(function (el) { return !el.checkValidity(); });
      bad.forEach(function (el) { mark(el, true); });

      if (bad.length) {
        e.preventDefault();
        bad[0].focus();
        return;
      }

      /* Prototype stand-in: there is no endpoint behind this page, so rather than
         posting to "#" and reloading over the reader's message, the confirmation
         is shown in place. On Shopify this whole branch goes away — the form
         posts and `form.posted_successfully?` renders the same panel. */
      e.preventDefault();
      form.hidden = true;
      if (done) {
        done.hidden = false;
        done.focus();                      // move focus to what just appeared
      }
    });

    if (again) {
      again.addEventListener('click', function () {
        form.reset();
        fields.forEach(function (el) { mark(el, false); });
        if (done) done.hidden = true;
        form.hidden = false;
        var first = form.querySelector('input, select, textarea');
        if (first) first.focus();
      });
    }
  }

  boot();

  /* The editor replaces a section's markup wholesale on every change, so the
     script has to run again over the new nodes. Storefront visitors never get
     here -- they booted once above. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { boot(); });
  }
})();
